/**
 * /public/css/form.css
 */

import React from "react";

/**
 * @param {*} props
 * @returns {}
 */
export default function ButtonClean(props) {
    return (
        <button tabIndex={0} type="button" className="button-clean" {...props}>
            {props.children}
        </button>
    );
}
